import { AccountData, HolidayCalendar } from '../api';

export const getDateFormat = (account?: AccountData) => {
  const isUS = account?.holiday_calendar === HolidayCalendar.US;
  return {
    shortDateFormat: isUS ? 'MM/DD' : 'DD/MM',
    longDateFormat: isUS ? 'MM/DD/YYYY' : 'DD/MM/YYYY',
  };
};

export const getTimeFormat = (account?: AccountData) => {
  if (!account) {
    return 'HH:mm';
  }
  return account.holiday_calendar === HolidayCalendar.US ? 'h:mm A' : 'HH:mm';
};
